import { postRequest } from "../requests";
import { SurveyReference } from "./survey";

export interface SurveyStepViewedEvent {
    SurveyID: string;
    SurveySessionID: string;
    TaskID?: string;
    SurveyVersion: number;
    Context: "NoTask" | "TaskBased" | "Consent";
    StepIdentifier: string;
    SubStepIdentifier?: string;
    SubStepIndex?: number;
    ProjectRecordAuthorityCode?: string;
    ClientLocalTimestamp?: string;
    EventID?: string;
    PreviousEventID?: string;
    TaskRunUUID?: string;
    ParticipantID?: string;
    Instance?: string;
    UtmCampaign?: string;
    UtmContent?: string;
    UtmMedium?: string;
    UtmSource?: string;
    UtmTerm?: string;
    Fbclid?: string;
    Gclid?: string;
    Ndclid?: string;
}


export const trackingParameterToPropertyMap: { [key: string]: string } = {
    'utm_source': 'UtmSource',
    'utm_medium': 'UtmMedium',
    'utm_campaign': 'UtmCampaign',
    'utm_term': 'UtmTerm',
    'utm_content': 'UtmContent',
    'fbclid': 'Fbclid',
    'ndclid': 'Ndclid',
    'gclid': 'Gclid'
};

export const knownTrackingParameters = Object.keys(trackingParameterToPropertyMap);

export default function getStepViewLogger(survey: SurveyReference) {
    let url = 'api/researchkit/analytics/trackSurveyStepViewed';
    if (survey?.linkIdentifier) {
        url = `api/researchkit/anonymoussurveys/link/${survey.linkIdentifier}/trackSurveyStepViewedEvent`;
    } else if (survey?.linkKey) {
        url = `api/researchkit/surveylink/${survey.linkKey}/trackSurveyStepViewedEvent`;
    }

    return function (event: SurveyStepViewedEvent) {
        var urlParams = new URLSearchParams(window.location.search);
        knownTrackingParameters.forEach(function (trackingParameter) {
            if (urlParams.has(trackingParameter)) {
                (event as any)[trackingParameterToPropertyMap[trackingParameter]] = urlParams.get(trackingParameter);
            }
        });

        return postRequest(url, event);
    }
}